export const BUILD_VERSION = '1788559301';
